<template>
    <div>
        <div class="page-header" v-bind:style="{ 'background-image': 'url(' + image + ')', 'background-size': 'cover' }">
			<div class="container">
				<div class="row">
					<div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
						<div class="page-caption">
							<h1 class="page-title">
                            <img alt="Insurtech" v-bind:src="require('../../assets/images/insurtech_logo.png')" style="height: 57px;margin-top:119px" />
                            </h1> </div>
					</div>
				</div>
			</div>
		</div>
        	<div class="card-section">  
			<div class="container">
				<div class="card-block bg-white mb30" style="box-shadow:4px 18px 22px aliceblue">
					<div class="row">
						<div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
							<!-- section-title -->
							<div class="section-title mb-0">
								<div class="" v-if="invite !=''">
                                    <div class="" style="background:gainsboro; padding:25px">
                                        <h5>{{ invite.Hi }} {{invite.name}} </h5>
                                        <span style="font-size:14px">{{invite.invite_msg_1}}</span><br>
                                        <span style="font-size:14px">{{invite.invite_msg_2}}</span><br>
                                        <span style="font-size:14px">{{invite.invite_msg_3}}</span><br>
                                    </div>
                                    <hr />
                                    <div class="" style="margin-top:20px">
                                    <span>{{invite.thanks}} <br> Insurtech </span> 
                                    <br />
                                    </div>
                                </div>
                                <h3 v-if="insurance !=''"> {{insurance.subject}} </h3>
                                <br />
                                <div class="row" v-if="insurance != ''">
                                    <div class="form-group col-sm-4">
                                        <label class="label yb-label">{{insurance.termination_title}}</label> <br>
                                        <span> {{insurance.termination}} </span>
							        </div>
                                    <div class="form-group col-sm-4">
                                        <label class="label yb-label">{{insurance.police_title}}</label> <br>
                                        <span> {{insurance.police_no}} </span>
							        </div>
                                    <div class="form-group col-sm-4">
                                        <label class="label yb-label">{{insurance.insurance_title}}</label> <br>
                                        <span> {{insurance.insurance}} </span>
							        </div>

                                    <div class="col-sm-12">
                                    <hr />
                                    </div>

                                    <div class="form-group col-sm-4">
                                        <label class="label yb-label">{{insurance.user_name}}</label> <br>
                                        <span> {{insurance.name}} </span>
							        </div>
                                    <div class="form-group col-sm-4">
                                        <label class="label yb-label">CVR</label> <br>
                                        <span> {{insurance.cvr}} </span>
							        </div>
                                    <div class="form-group col-sm-4">
                                        <label class="label yb-label">Reg No</label> <br>
                                        <span> {{insurance.reg_no}} </span>
							        </div>

                                    <div class="col-sm-12">
                                    <hr />
                                     </div>

                                    <div class="form-group col-sm-12">
                                        <label class="label yb-label">{{insurance.frame_title}}</label> <br>
                                        <span> {{insurance.frame_number}} </span>
							        </div>

                                </div>

                                <div class="row" v-if="insurance !='' ">
                                         <div class="col-sm-12" style="margin-top:20px">
                                     <span>{{insurance.thanks}} <br> Insurtech </span> 
                                    <br />
                                </div>
                                </div>
                                <h3 v-if="info !=''"> {{info.subject}} </h3>
                                <br />
                                <div class="row" v-if="info != ''">   
                                    <div class="form-group col-sm-4">
                                        <label class="label yb-label">{{ $t('message.USER_INFO')}}</label> <br>
                                        <span> {{info.name}} </span>
							        </div>
                                    <div class="form-group col-sm-4">
                                        <label class="label yb-label">{{ $t('message.EMAIL')}}</label> <br>
                                        <span> {{info.email}} </span>
							        </div>
                                    <div class="form-group col-sm-4">
                                        <label class="label yb-label">{{ $t('message.TELEPHONE')}}</label> <br>
                                        <span> {{info.telephone}} </span>
							        </div>

                                    <div class="col-sm-12">
                                    <hr />
                                    </div>

                                    <div class="form-group col-sm-4">
                                        <label class="label yb-label">CVR</label> <br>
                                        <span> {{info.cvr}} </span>
							        </div>
                                    <div class="form-group col-sm-4">
                                        <label class="label yb-label">{{ $t('message.NEW_VALUE')}}</label> <br>
                                        <span> {{info.new_value}} </span>
							        </div>
                                    <div class="form-group col-sm-4">
                                        <label class="label yb-label">{{ $t('message.OWN_RISK')}}</label> <br>
                                        <span> {{info.own_risk}} </span>
							        </div>

                                    <div class="col-sm-12">
                                    <hr />
                                    </div>

                                    <div class="form-group col-sm-4">
                                        <label class="label yb-label">Address</label> <br>
                                        <span> {{info.address}} </span>
							        </div>
                                    <div class="form-group col-sm-4">
                                        <label class="label yb-label">{{ $t('message.ZIP_CODE')}}</label> <br>
                                        <span> {{info.zip_code}} </span>
							        </div>
                                     <div class="form-group col-sm-4">
                                        <label class="label yb-label">{{ $t('message.CITY')}}</label> <br>
                                        <span> {{info.city}} </span>
							        </div>

                                    <div class="col-sm-12">
                                     <hr />
                                    </div>
                                    
                                    <div class="form-group col-sm-4">
                                        <label class="label yb-label"></label> <br>
                                        <span> {{$t('message.WANT_ROADSIDE_ASSISTANCE')}} : {{ (info.glass_damage == '1' ? $t('message.YES') : $t('message.NO'))}} </span>
							        </div>

                                       
                                    <div class="form-group col-sm-4">
                                        <label class="label yb-label"></label> <br>
                                        <span> {{$t('message.WANT_GLASS_DAMAGE')}} : {{ (info.roadside == '1' ? $t('message.YES') : $t('message.NO'))}} </span>
							        </div>
                                </div>

                                <div class="row" v-if="info !=''">
                                <div class="col-sm-12" style="margin-top:20px">
                                     <span>{{info.thanks}} <br> Insurtech </span> 
                                    <br />
                                </div>
                                </div>

                                <h3 v-if="work_insur !=''"> {{work_insur.subject}} </h3>
                                <br />
                                <div class="row" v-if="work_insur != ''">   
                                    <div class="form-group col-sm-4">
                                        <label class="label yb-label">{{ $t('message.USER_INFO')}}</label> <br>
                                        <span> {{work_insur.name}} </span>
							        </div>
                                    <div class="form-group col-sm-4">
                                        <label class="label yb-label">{{ $t('message.EMAIL')}}</label> <br>
                                        <span> {{work_insur.email}} </span>
							        </div>
                                    <div class="form-group col-sm-4">
                                        <label class="label yb-label">{{ $t('message.TELEPHONE')}}</label> <br>
                                        <span> {{work_insur.telephone}} </span>
							        </div>

                                    <div class="col-sm-12">
                                    <hr />
                                    </div>

                                    <div class="form-group col-sm-4">
                                        <label class="label yb-label">CVR</label> <br>
                                        <span> {{work_insur.cvr}} </span>
							        </div>

                                    <div class="form-group col-sm-4">
                                        <label class="label yb-label">Address</label> <br>
                                        <span> {{work_insur.address}} </span>
							        </div>
                                    <div class="form-group col-sm-4">
                                        <label class="label yb-label">{{ $t('message.ZIP_CODE')}}</label> <br>
                                        <span> {{work_insur.zip_code}} </span>
							        </div>

                                    <div class="col-sm-12">
                                    <hr />
                                    </div>

                                     <div class="form-group col-sm-4">
                                        <label class="label yb-label">{{ $t('message.CITY')}}</label> <br>
                                        <span> {{work_insur.city}} </span>
							        </div>
                                    
                                    <div class="form-group col-sm-4">
                                        <label class="label yb-label"></label> <br>
                                        <span> {{work_insur.label}} : {{ (work_insur.work == '1' ? $t('message.YES') : $t('message.NO'))}} </span>
							        </div>

                                      <div class="form-group col-sm-4">
                                        <label class="label yb-label">{{ $t('message.NUMBER_OF_CARS')}}</label> <br>
                                        <span> {{work_insur.cars}} </span>
							        </div>


                                    <div class="col-sm-12">
                                    <hr />
                                    </div>

                                      <div class="form-group col-sm-4">
                                        <label class="label yb-label">{{ $t('message.NUMBER_OF_EMPLOYEES')}}</label> <br>
                                        <span> {{work_insur.employee}} </span>
							        </div>

                                      <div class="form-group col-sm-4">
                                        <label class="label yb-label">{{ $t('message.DRIVERS')}}</label> <br>
                                        <span> {{work_insur.drivers}} </span>
							        </div>
                                    

                                </div>
                                 <div class="row" v-if="work_insur !=''">
                                <div class="col-sm-12" style="margin-top:20px">
                                     <span>{{work_insur.thanks}} <br> Insurtech </span> 
                                    <br />
                                </div>
                                </div>
                                 
                               
							</div>
							<!-- /.section-title -->
						</div>
					</div>
				
				</div>
				<div class="row"> </div>
			</div>
		</div>
    </div>
</template>
<script>
import Vue from 'vue'

export default {
    data(){
        return {
           invite : '',
           insurance:'',
           info:'',
           work_insur:'',
           image : require("../../assets/images/ensure_header.jpg"),

        }
    },

    methods:{
        async get_mail_info()
        {
            let form_data = {
                msg:this.$route.params.mail,
                token:this.$route.params.token,
                locale: this.$route.params.locale,
            }

            try 
            {
                let data_obj = await Vue.prototype.$http.post('/api/step/email-info', form_data)
                if(this.$route.params.mail == 'invite')
                {
                    this.invite = data_obj.data.data
                }
                else if(this.$route.params.mail == 'existing-insurance')
                {
                    this.insurance = data_obj.data.data
                }
                else if(this.$route.params.mail == 'injury-insurance')
                {
                   this.info = data_obj.data.data
                }
                else if(this.$route.params.mail == 'work-insurance')
                {
                   this.work_insur = data_obj.data.data
                }

                this.$i18n.locale = this.$route.params.locale
    
            } catch (error) {
                this.$store.dispatch('notifications_alert/error', this.$t('message.SOMETHING_WENT_WRONG'))

            }
        }
    },
    created()
    {
        this.get_mail_info()
    }
}
</script>
<style scoped>
body { -webkit-font-smoothing: antialiased; text-rendering: optimizeLegibility; font-family: 'Overpass', sans-serif; letter-spacing: 0px; font-size: 17px; color: #8d8f90; font-weight: 400; line-height: 32px; background-color: #edefef; }
h1, h2, h3, h4, h5, h6 { color: #25292a; margin: 0px 0px 10px 0px; font-family: 'Overpass', sans-serif; font-weight: 700; letter-spacing: -1px; line-height: 1; }
h1 { font-size: 34px; }
h2 { font-size: 28px; line-height: 38px; }
h3 { font-size: 22px; line-height: 32px; }
h4 { font-size: 20px; }
h5 { font-size: 17px; }
h6 { font-size: 12px; }
p { margin: 0 0 20px; line-height: 1.7; }
p:last-child { margin: 0px; }
ul, ol { }
a { text-decoration: none; color: #8d8f90; -webkit-transition: all 0.3s; -moz-transition: all 0.3s; transition: all 0.3s; }
a:focus, a:hover { text-decoration: none; color: #f85759; }



.page-caption { padding-top: 47px; padding-bottom: 174px; }
.page-title { font-size: 46px; line-height: 1; color: #fff; font-weight: 600; text-align: center; }

.card-section { position: relative; bottom: 60px; }
.card-block { padding: 80px; }
.section-title { margin-bottom: 60px; }
.form-check input[type="checkbox"], .form-check-radio input[type="radio"] {
	visibility: visible  !important;
	opacity: 1;
}
.form-check .form-check-label {
	line-height: 39px !important;
	padding-left: 25px  !important;
}
.invalid-field {
    width: 100%;
    margin-top: 0.25rem;
    font-size: 80%;
    color: #dc3545;
}
.yb-label{
    font-weight: bold;
}


</style>